@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}

<div class="container-fluid glb-popup py-3">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
    <div>
      @if (formReadOnly) {
        <h5 class="mb-1 text-primary fw-600">{{ inbox.subject }}</h5>
      }
      <span class="text-muted fw-bold my-2">{{ inbox?.createDate | date: 'medium' }}</span>
    </div>
    <div class="d-flex flex-wrap gap-2 small">
      @if (inbox?.reservationAPI?.order?.orderId) {
        <span>
          <a target="_blank" class="text-primary"
            [href]="'https://admin.kbmhawaii.com/order/' + inbox.reservationAPI.order.orderId">
            Order# {{inbox.reservationAPI.order.orderId}} /
            Res# {{inbox.reservationAPI.reservationId}}
          </a>
        </span>
      }
      @if (inbox?.reservationAPI?.shortTermRental) {
        <span>
          <a target="_blank" class="text-primary"
            [href]="'https://admin.kbmhawaii.com/property-edit/' + inbox.reservationAPI.shortTermRental.shortTermRentalId">
            Property {{ inbox.reservationAPI.shortTermRental.propertyCode }}
          </a>
        </span>
      }
    </div>
  </div>

  @if (!formReadOnly) {
    <h5 class="mb-2">{{ formTitle }}</h5>
  }

  <!-- Toast & Confirm Dialog -->
  <p-toast [style]="{ marginTop: '60px' }"></p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <!-- Close -->
  @if (showClose) {
    <button [mat-dialog-close]="showClose" class="p-button p-button-text float-end mt-n4">
      <i class="pi pi-times"></i>
    </button>
  }

  <form [formGroup]="form1" class="forms w-100">

    <!-- Alert -->
    @if (formAlert) {
      <div class="alert alert-warning text-center small py-2">
        <b>{{ formAlert }}</b>
      </div>
    }

    <div class="d-flex flex-wrap gap-2 my-2">
      <div class="floating-label-wrapper">
        <p-dropdown dropdownIcon="fa fa-caret-down" appendTo="body" [options]="msgContexts" [(ngModel)]="msgContextId"
          [ngModelOptions]="{ standalone: true }" [filter]="true" optionLabel="name" optionValue="value"
          (onChange)="onMsgContextChange($event.value)" styleClass="filter-dropdown" appendTo="body">
        </p-dropdown>
        <label class="floating-label"
        [class.floating-label-active]="msgContextId !== null && msgContextId !== undefined">Msg Context</label>
      </div>
      <div class="floating-label-wrapper">
        <p-dropdown dropdownIcon="fa fa-caret-down" appendTo="body" [options]="msgSubContextsFiltered"
          [(ngModel)]="msgSubContextId" [ngModelOptions]="{ standalone: true }" [filter]="true" optionLabel="name"
          optionValue="value" (onChange)="onMsgSubContextChange($event.value)" styleClass="filter-dropdown" appendTo="body">
        </p-dropdown>
        <label class="floating-label"
        [class.floating-label-active]="msgSubContextId !== null && msgSubContextId !== undefined">Msg Sub Context</label>
      </div>

      <div class="floating-label-wrapper">
        <p-dropdown dropdownIcon="fa fa-caret-down" appendTo="body" [options]="msgRoles" [(ngModel)]="msgRoleId"
          [ngModelOptions]="{ standalone: true }" [filter]="true" optionLabel="name" optionValue="value"
          (onChange)="onMsgRoleChange($event.value)" styleClass="filter-dropdown" appendTo="body">
        </p-dropdown>
        <label class="floating-label" [class.floating-label-active]="msgRoleId !== null && msgRoleId !== undefined">Msg
        Role</label>
      </div>
      <div>
        @if (inboxId) {
          <app-tag-join-select [tagSource]="120" [tagSourceId]="inboxId" tagType="4"
          class="flex-grow-1"
          (tagsSelectedEvent)="onMailTagsSelected($event)"></app-tag-join-select>
        }
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="d-flex flex-wrap align-items-center gap-1 mb-3" role="toolbar" aria-label="Mail actions">

      <!-- Reply -->
      @if (inboxId) {
        <button #btnReplayEmail pButton
          [disabled]="!isReplyEnable || isAnyBusy"
          [attr.aria-busy]="isReplying"
          aria-label="Reply to this email"
          class="p-button-sm bg-primary inbox-action-btn"
          (click)="replyMail()">
          @if (isReplying) {
            <i class="pi pi-spin pi-spinner me-1" aria-hidden="true"></i>
          }
          @if (!isReplying) {
            <i class="pi pi-reply me-1" aria-hidden="true"></i>
          }
          {{ isReplying ? 'Replying…' : 'Reply' }}
        </button>
      }

      <!-- Forward -->
      @if (inboxId) {
        <button pButton
          [disabled]="!isReplyEnable || isAnyBusy"
          [attr.aria-busy]="isForwarding"
          aria-label="Forward this email"
          class="p-button-sm bg-primary inbox-action-btn"
          (click)="forwardMail()">
          @if (isForwarding) {
            <i class="pi pi-spin pi-spinner me-1" aria-hidden="true"></i>
          }
          @if (!isForwarding) {
            <i class="pi pi-arrow-right me-1" aria-hidden="true"></i>
          }
          {{ isForwarding ? 'Forwarding…' : 'Forward' }}
        </button>
      }

      <!-- Send -->
      <button pButton
        [disabled]="!isSendEnable || isAnyBusy"
        [attr.aria-busy]="isSending"
        aria-label="Send email"
        class="p-button-sm bg-primary inbox-action-btn"
        (click)="sendMail()">
        @if (isSending) {
          <i class="pi pi-spin pi-spinner me-1" aria-hidden="true"></i>
        }
        @if (!isSending) {
          <i class="pi pi-send me-1" aria-hidden="true"></i>
        }
        {{ isSending ? 'Sending…' : 'Send' }}
      </button>

      <!-- Cancel -->
      <button pButton
        [disabled]="!isSendEnable || isAnyBusy"
        aria-label="Cancel edit"
        class="p-button-sm bg-primary inbox-action-btn"
        (click)="cancelEdit()">
        <i class="pi pi-times me-1" aria-hidden="true"></i>
        Cancel
      </button>

      <!-- Archive -->
      @if (inbox?.msgFolder !== 2) {
        <button pButton
          [disabled]="isAnyBusy"
          [attr.aria-busy]="isArchiving"
          aria-label="Archive this message"
          class="p-button-sm bg-primary inbox-action-btn"
          (click)="archiveMsg(inbox)">
          @if (isArchiving) {
            <i class="pi pi-spin pi-spinner me-1" aria-hidden="true"></i>
          }
          @if (!isArchiving) {
            <i class="pi pi-inbox me-1" aria-hidden="true"></i>
          }
          {{ isArchiving ? 'Archiving…' : 'Archive' }}
        </button>
      }

      <!-- View Task -->
      @if (inbox?.taskAPIList?.length > 0 && !fromTask) {
        <button pButton
          [disabled]="isAnyBusy"
          aria-label="View tasks for this message"
          class="p-button-sm bg-primary inbox-action-btn"
          (click)="openViewTask(inbox)">
          <i class="pi pi-list me-1" aria-hidden="true"></i>View Task
        </button>
      }

      <!-- Add Task -->
      @if (inbox) {
        <button pButton
          [disabled]="isAnyBusy"
          aria-label="Add a task for this message"
          class="p-button-sm bg-primary inbox-action-btn"
          (click)="openCreateTask(inbox)">
          <i class="pi pi-plus-circle me-1" aria-hidden="true"></i>Add Task
        </button>
      }

      <!-- Tape Chart — opens grid in standard date mode, no Best Fit panel -->
      @if (inbox) {
        <button pButton
          [disabled]="isAnyBusy"
          aria-label="Open tape chart"
          class="p-button-sm bg-primary inbox-action-btn"
          (click)="openTapChart(inbox)">
          <i class="pi pi-calendar me-1" aria-hidden="true"></i>Tape Chart
        </button>
      }

      <!-- Best Fit Finder — always visible; pre-fills from Smart Parse context when available -->
      @if (inbox) {
        <button pButton
          [disabled]="isAnyBusy"
          aria-label="Open Best Fit window finder"
          class="p-button-sm inbox-action-btn-bestfit"
          (click)="openBestFitList(inbox)">
          <i class="pi pi-star-fill me-1" aria-hidden="true"></i>
          @if (parsedContext?.flexMode && parsedContext?.flexNumNights) {
            Find {{ parsedContext.flexNumNights }}-night Windows
          } @else {
            Best Fit Finder
          }
        </button>
      }

    </div>

    <!-- ============================================================= -->
    <!--  SMART PARSE BANNER                                            -->
    <!--  Shows chips for every detail QuoteContextService pulled out   -->
    <!--  of the email, plus a one-click "Open in Tape Chart"           -->
    <!-- ============================================================= -->
    @if (inbox && parsedContext && parseBannerVisible &&
         (parsedContext.detected.length > 0 || parsedContext.confidence !== 'low')) {
      <div class="smart-parse-banner" role="region" aria-label="Smart-parsed quote context"
           [class.banner-high]="parsedContext.confidence === 'high'"
           [class.banner-med]="parsedContext.confidence === 'medium'"
           [class.banner-low]="parsedContext.confidence === 'low'">
        <div class="spb-left">
          <i class="pi pi-bolt spb-icon" aria-hidden="true"></i>
          <span class="spb-title">Smart Parse</span>
          <span class="spb-conf" [ngClass]="'conf-' + parsedContext.confidence">
            {{ parsedContext.confidence | titlecase }} confidence
          </span>
        </div>

        <div class="spb-chips">
          @if (parsedContext.flexMode) {
            <span class="spb-chip flex-chip" title="Flexible date request">
              <i class="pi pi-sync"></i>
              Any {{ parsedContext.flexNumNights }} nights
              · {{ parsedContext.flexRangeStart | date:'MMM d' }}
                – {{ parsedContext.flexRangeEnd   | date:'MMM d' }}
            </span>
          }
          @if (!parsedContext.flexMode && parsedContext.checkInDate && parsedContext.checkOutDate) {
            <span class="spb-chip">
              <i class="pi pi-calendar"></i>
              {{ parsedContext.checkInDate  | date:'MMM d' }}
              – {{ parsedContext.checkOutDate | date:'MMM d' }}
            </span>
          }
          @if (parsedContext.resortLabel) {
            <span class="spb-chip"><i class="pi pi-home"></i> {{ parsedContext.resortLabel }}</span>
          }
          @if (parsedContext.propertyCode && !parsedContext.resortLabel) {
            <span class="spb-chip"><i class="pi pi-home"></i> {{ parsedContext.propertyCode }}</span>
          }
          @if (parsedContext.locationLabel && !parsedContext.resortLabel && !parsedContext.propertyCode) {
            <span class="spb-chip"><i class="pi pi-map-marker"></i> {{ parsedContext.locationLabel }}</span>
          }
          <span class="spb-chip">
            <i class="pi pi-users"></i>
            {{ parsedContext.numAdults }} adult{{ parsedContext.numAdults === 1 ? '' : 's' }}
            @if (parsedContext.numChildren > 0) {
              , {{ parsedContext.numChildren }} child{{ parsedContext.numChildren === 1 ? '' : 'ren' }}
            }
          </span>
          @if (parsedContext.guestPhone) {
            <span class="spb-chip"><i class="pi pi-phone"></i> {{ parsedContext.guestPhone }}</span>
          }
        </div>

        <div class="spb-right">
          <!-- CTA only for flex requests — opens Best Fit Finder (different from Tape Chart toolbar) -->
          <!-- Non-flex: no CTA needed; the "Tape Chart" toolbar button already handles this -->
          @if (parsedContext.flexMode) {
            <button pButton
                    class="p-button-sm p-button-success spb-cta"
                    (click)="openBestFitList(inbox)"
                    aria-label="Open Best Fit window finder">
              <i class="pi pi-star-fill me-1"></i>Find {{ parsedContext.flexNumNights }}-night Windows
            </button>
          }
          <button pButton
                  class="p-button-sm p-button-text spb-reparse"
                  (click)="runSmartParse()"
                  pTooltip="Re-analyze email"
                  tooltipPosition="top"
                  aria-label="Re-run smart parse">
            <i class="pi pi-refresh"></i>
          </button>
          <button pButton
                  class="p-button-sm p-button-text spb-dismiss"
                  (click)="dismissParseBanner()"
                  pTooltip="Dismiss"
                  tooltipPosition="top"
                  aria-label="Hide smart parse banner">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
    }




    <!-- Recipient Fields -->
    @if (isSendEnable) {
      <div class="row g-2 mb-2">
        <div class="col-md-6">
          <p-dropdown
            [options]="msgTemplates"
            formControlName="msgTemplateId"
            optionLabel="name"
            optionValue="msgTemplateId"
            placeholder="Select Template"
            [filter]="true"
            filterBy="name,msgTemplateId"
            (onChange)="selectTemplate($event)"
            class="w-100">
            <ng-template pTemplate="item" let-item>
              <span>#{{item.msgTemplateId}} — {{item.name}}</span>
            </ng-template>
            <ng-template pTemplate="selectedItem" let-item>
              <span>#{{item.msgTemplateId}} — {{item.name}}</span>
            </ng-template>
          </p-dropdown>
        </div>
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <label class="form-label">To:</label>
          <app-contact-select [contacts]="defaultContacts" (contactSelectedEvent)="toMailSelected($event)"></app-contact-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">CC:</label>
          <app-contact-select (contactSelectedEvent)="ccMailSelected($event)"></app-contact-select>
        </div>
        <div class="col-md-3">
          <label class="form-label">BCC:</label>
          <app-contact-select (contactSelectedEvent)="bccMailSelected($event)"></app-contact-select>
        </div>
        <div class="col-md-12">
          <input type="text" class="form-control form-control-sm" formControlName="subject" />
          @for (validation of validationMessages.subject; track validation) {
            @if (form1.get('subject')?.hasError(validation.type)) {
              <small class="text-danger">
                {{ validation.message }}
              </small>
            }
          }
        </div>
        @if (inbox?.msgOrigin && inbox?.msgOrigin == '4') {
          <div class="col-md-12 mt-2">
            <label class="form-label">Attachments:</label>
            <p-fileUpload
              name="attachments[]"
              mode="basic"
              chooseLabel="Browse..."
              accept=".jpg,.jpeg,.png,.gif,.pdf,.xls,.xlsx"
              [multiple]="true"
              maxFileSize="52428800"
              (onSelect)="onFilesSelect($event)"
              [auto]="false">
            </p-fileUpload>
            @if (attachments.length > 0) {
              <ul class="mt-2 small list-unstyled">
                @for (file of attachments; track file; let i = $index) {
                  <li class="d-flex align-items-center justify-content-between border p-1 rounded mb-1">
                    <span>
                      📎 {{ file.filename }}
                      <small class="text-muted">({{ file.contentType }}, {{ (file.contentBytes.length / 1024) | number:'1.0-0' }} KB)</small>
                    </span>
                    <button type="button" pButton icon="pi pi-times" class="p-button-text p-button-danger p-button-sm"
                    (click)="removeAttachment(i)"></button>
                  </li>
                }
              </ul>
            }
          </div>
        }
      </div>
    }

    <!-- Message Body -->
    <div class="mt-3">
      <!-- Show emailText if exists -->
      @if ((!inbox?.emailHtml && inbox?.emailText) || inbox?.msgOrigin == '4') {
        @if (formReadOnly) {
          <div class="email-preview" [innerHTML]="form1.get('emailText')?.value"></div>
        }
        @if (!formReadOnly) {
          <textarea formControlName="emailText" pInputTextarea rows="15" class="w-100"
          [disabled]="formReadOnly"></textarea>
        }
      } @else {
        <small class="text-muted d-block mb-2">
          <a href="#" (click)="onKeywordClick(inbox?.senderName, $event)">
            {{ inbox?.senderName }}
          </a>
          &lt;
          <a href="#" (click)="onKeywordClick(inbox?.senderEmail, $event)">
            {{ inbox?.senderEmail }}
          </a>
          &gt;
          to:
          <a href="#" (click)="onKeywordClick(inbox?.msgRecipientAPIList[0]?.lastName, $event)">
            {{ inbox?.msgRecipientAPIList[0]?.lastName }}
          </a>
          &lt;
          <a href="#" (click)="onKeywordClick(inbox?.msgRecipientAPIList[0]?.email, $event)">
            {{ inbox?.msgRecipientAPIList[0]?.email }}
          </a>
          &gt;
          <!-- {{ inbox?.senderName }} &lt;{{ inbox?.senderEmail }}&gt; to:
          {{ inbox?.msgRecipientAPIList[0]?.lastName }} &lt;{{ inbox?.msgRecipientAPIList[0]?.email }}&gt; -->
        </small>
        @if (formReadOnly) {
          <div class="email-preview" [innerHTML]="safeEmailHtml"></div>
        }
        @if (!formReadOnly) {
          @if (editorLoading) {
            <div class="d-flex align-items-center gap-2 mb-2">
              <i class="pi pi-spin pi-spinner"></i>
              <span>Loading editor...</span>
            </div>
          }
<editor #mailEditor formControlName="emailHtml" [init]="{
                height: 500,
                base_url: '/tinymce',
                suffix: '.min',
                menubar: !formReadOnly,
                plugins: 'link image table code lists',
                toolbar: 'undo redo | bold italic | alignleft aligncenter alignright | bullist numlist | link'
              }" (onInit)="onEditorInit()" class="w-100">
          </editor>
        }
      }
      <!-- Show emailHtml otherwise -->
    </div>

    @if (inbox?.msgAttachments?.length > 0) {
      <div class="received-attachments">
        <div class="received-attachments-header">
          <i class="pi pi-paperclip"></i>
          <span>{{ inbox.msgAttachments.length }} Attachment{{ inbox.msgAttachments.length > 1 ? 's' : '' }}</span>
        </div>
        <div class="received-attachments-list">
          @for (att of inbox.msgAttachments; track att; let i = $index) {
            <a
              href="javascript:void(0)"
              (click)="openAttachment(inbox.msgId, i)"
              class="received-attachment-item"
              [class.att-loading]="downloadingAttachment[i]"
              [title]="att.fileName || att.filename || 'Attachment'">
              <span class="received-attachment-icon">
            <i [class]="downloadingAttachment[i]
                 ? 'pi pi-spin pi-spinner'
                 : getAttachmentIcon(att.fileName || att.filename || att.contentType)">
                </i>
              </span>
              <span class="received-attachment-name">{{ att.fileName || att.filename || 'Attachment' }}</span>
              @if (att.fileSize) {
                <span class="received-attachment-size">
                  {{ (att.fileSize / 1024) | number:'1.0-0' }} KB
                </span>
              }
              @if (!downloadingAttachment[i]) {
                <i class="pi pi-download received-attachment-open"></i>
              }
            </a>
          }
        </div>
      </div>
    }

    @if (form1.get('msgId')?.value) {
      <app-msg-recipient-list
        [msgId]="form1.get('msgId')?.value"
        [showPagination]="false"
        [showFilter]="false"
        [showAddRecipient]="false">
      </app-msg-recipient-list>
    }

    <!-- Send -->
    <div class="text-end mt-3">
      <button pButton label="Send" class="p-button-sm" [disabled]="!isSendEnable || isSending" (click)="sendMail()"></button>
    </div>

  </form>
